<template>
  <div class="bossindex">

          <Content>
            <!-- 面包屑 -->
            <div style=" margin: 20px 0 0 20px">
              <Breadcrumb :style="{margin: '24px 0'}">
                <Icon type="ios-home" class="icon-breadcrumb" />
                <Breadcrumb style="display: inline-block">
                  <BreadcrumbItem to="/main">店铺</BreadcrumbItem>
                  <BreadcrumbItem v-if="title!='首页'">{{title}}</BreadcrumbItem>
                </Breadcrumb>
              </Breadcrumb>
              <router-view></router-view>
            </div>
           <!-- 增值服务 -->

            <Footer>
              <div class="footerNav">
                <Row>
                  <Col span="4">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div>
                        <router-link to="/ExtendedServices">
                          <img src="../assets/img/tools/tool-server.png" alt="增值服务">
                          <p>延伸服务</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>
                  <Col span="4">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div style="text-align:center">
                        <router-link to="/integralSetUp">
                          <img src="../assets/img/tools/IntegralSettings.png" alt="积分设置">
                          <p>积分设置</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>
                  <Col span="4">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div style="text-align:center">
                        <router-link to="/companyMsg">
                          <img src="../assets/img/tools/CompanyMsg.png" alt="公司信息">
                          <p>公司信息</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>
                 <!-- <Col span="3">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div style="text-align:center">
                        <router-link to="/statisticsSum">
                          <img src="../assets/img/tools/Company.png" style="width: 34px" alt="统计概况">
                          <p>统计概况</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>-->
                  <Col span="4">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div>
                        <router-link to="/colorLib">
                          <img src="../assets/img/tools/colorSet.png" alt="颜色库设置">
                          <p>颜色库设置</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>
                  <Col span="4">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div style="text-align:center">
                        <router-link to="/sizeLib">
                          <img src="../assets/img/tools/sizesetting.png" alt="规格库设置">
                          <p>规格库设置</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>
                  <!--<Col span="3">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div>
                        <router-link to="/staffResult">
                          <img src="../assets/img/tools/achievement.png" alt="员工业绩">
                          <p>员工业绩</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>-->
                  <!--<Col span="3">
                    <Card class="baseTool" :bordered="false" dis-hover>
                      <div style="text-align:center">
                        <router-link to="/rechargeRecord">
                          <img src="../assets/img/tools/agent.png" alt="会员充值">
                          <p>会员充值</p>
                        </router-link>
                      </div>
                    </Card>
                  </Col>-->
                </Row>
              </div>
            </Footer>
        </Content>
    <template>
</template>
<!--基础功能-->

  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      cid: "",
      id: "",
      shipId: "",
      navList:[],
      shopList: {},
      delModal: false,
      sendCodeModel: false,
      addShopModal: false,
      loading: false,
      sendCode: "",
      type: "",
      buttonText: "添加",
      buttonTexta: "加载中",
      formValidate: {
        name: "",
        address: "",
        tel: ""
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "店铺名称不能为空,且不能超过32位字符",
            trigger: "blur"
          }
        ],
        address: [{ required: true, message: "地址不能为空", trigger: "blur" }],
        tel: [{ required: true, message: "电话不能为空", trigger: "blur" }]
      }
    };
  },
  computed: {
    title() {
      return this.$route.meta.title;
      shopName:''
    }
  },

  created: function() {

  },
  methods: {
  }
};
</script>


<style lang="scss" scoped>
.bossindex {
  position: relative;
  padding-bottom: 100px;
}
.shop_list {
  padding-top: 20px;
  padding-left: 26px;
  overflow: auto;
  .card {
    width: 350px;
    float: left;
    margin: 30px 60px;
    box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
    border-radius: 10px;
    cursor: pointer;
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.ShopTitle {
  position: relative;
  padding-left: 36px;
  width: 94%;
  overflow: auto;
}
.shipImg {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline;
}

#addShop {
  box-shadow: 0px 0px 0px 0px;
  border-radius: 10px;
  border: dashed 4px #68a1ff;
  height: 127px;
  padding-top: 18px;

  img {
    margin: auto;
    outline: none;
  }
}
  .footerNav{
    background: #ffffff;
    position: fixed;
    bottom: 5px;
    left: 5%;
    width: 80%;
  }
.baseTool{
  div{
    text-align: center;
    cursor: pointer;
    img{
      display: block;
      margin: 10px auto;
      width: 40px;
    }
  }
}
</style>